import { URLBuilderLink } from 'lib/url/url-builder-link';

import { displayedName } from 'four-nets/user/utils';

export class UserLink extends URLBuilderLink {
    constructor(options) {
        const { user, urlBuilder, isVendor } = options;

        super({
            label: displayedName(user),
            url: isVendor ? 'vendor/profile' : 'user/profile',
            urlBuilder,
            value: {
                username: user.username,
            },
        });
    }
}
